import {usePath} from '@github-ui/code-view-shared/contexts/PathContext'
import {useRefInfo} from '@github-ui/code-view-shared/contexts/RefInfoContext'
import {useCurrentRepository} from '@github-ui/current-repository'
import {blobPath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'
import {AlertIcon} from '@primer/octicons-react'
/* eslint-disable-next-line primer-react/no-deprecated-flash -- Existing Flash usage should be migrated to Banner. */
import {Button, Flash, Link, Popover} from '@primer/react'
import {useCallback} from 'react'

import {useCurrentBlob} from '../../../hooks/CurrentBlob'
import styles from './DependabotConfigurationBanner.module.css'

export function DependabotConfigurationBanner() {
  const {defaultBranch} = useCurrentRepository()
  const {name: currentRef} = useRefInfo()
  const {
    dependabotInfo: {showConfigurationBanner},
  } = useCurrentBlob()

  if (!showConfigurationBanner) return null

  const isDefaultBranch = defaultBranch === currentRef

  return isDefaultBranch ? <DefaultBranchDependabotConfigurationBanner /> : <DirectionsForNonDefaultBranch />
}

function DefaultBranchDependabotConfigurationBanner() {
  const {
    dependabotInfo: {
      configFilePath,
      networkDependabotPath,
      dismissConfigurationNoticePath,
      configurationNoticeDismissed,
    },
  } = useCurrentBlob()

  const dismissNotice = useCallback(
    () => verifiedFetch(dismissConfigurationNoticePath, {method: 'POST'}),
    [dismissConfigurationNoticePath],
  )

  if (configurationNoticeDismissed) return null

  return (
    <div className={styles.Box}>
      <Popover caret="top" open>
        <Popover.Content>
          <h5 className={styles.Text}>Dependabot</h5>
          <p className={styles.Text_1}>
            Dependabot creates pull requests to keep your dependencies secure and up-to-date.
          </p>
          <p className={styles.Text_1}>
            You can opt out at any time by removing the <code>{configFilePath}</code> config file.
          </p>
          <div className={styles.Box_1}>
            <Button as="a" href={networkDependabotPath}>
              View update status
            </Button>
            <Button variant="invisible" onClick={dismissNotice} className={styles.Button}>
              Dismiss
            </Button>
          </div>
        </Popover.Content>
      </Popover>
    </div>
  )
}

function DirectionsForNonDefaultBranch() {
  const {defaultBranch, name, ownerLogin} = useCurrentRepository()
  const path = usePath()
  const defaultBranchPath = blobPath({owner: ownerLogin, repo: name, commitish: defaultBranch, filePath: path})
  return (
    <Flash variant="warning">
      <h5>
        <AlertIcon />
        Cannot configure Dependabot from this branch
      </h5>
      <p>
        To configure Dependabot, you must use{' '}
        <Link inline href={defaultBranchPath}>
          this repository&apos;s default branch
        </Link>
      </p>
    </Flash>
  )
}
